import _sortBy from 'lodash/sortBy';

function Ctrl($scope, jsSdkCity, metaTagService) {
  metaTagService.set({
    title: 'About Us | Tablelist',
    description: 'We live for nightlife, and we are proud to deliver a seamless VIP experience to our users in a growing list of cities.'
  });

  $scope.cities = [];

  jsSdkCity.list().then(function success(resp) {

    $scope.cities = _sortBy(resp, function(city) {
      return city.slugName;
    });

  }, function error() {});
}

Ctrl.$inject = [
  '$scope',
  'jsSdk.city',
  'metaTagService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/about/aboutCtrl.js